import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { EditorService } from 'src/app/shared/services/editor.service';

@Component({
    selector: 'add-user-modal',
    templateUrl: './add-user-modal.component.html',
    styleUrls: ['./add-user-modal.component.scss'],
})

export class AddUserModalComponent implements OnInit {

    @Input() public uid?: number;
    @Input() public tid?: string;
    teamMember = {
        email: '',
        audit: '',
        keywordReport: '',
        serp: ''
    }
    constructor(public activeModal: NgbActiveModal,
        private editorService: EditorService,
        private toastr: ToastrService) { }

    ngOnInit(): void {

    }
    addUser() {
        this.editorService.addTeamMember({
            "uid": this.uid,
            "tid": this.tid,
            "email": this.teamMember.email,
            "cred":  this.teamMember.audit,
            "kwCred":  this.teamMember.keywordReport,
            "serpCred": this.teamMember.serp,
        }).subscribe(res => {
            if(!!res && !!res.error){
                this.toastr.error(res.error);
            }
            if(!!res && !!res.success){
                this.toastr.success(res.success);
                this.teamMember = {
                    email: '',
                    audit: '',
                    keywordReport: '',
                    serp: ''
                }
                this.activeModal.close({data:"success"})
            }
        })
    }
}